var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Details felx flex_jc_sb"},[_c('DetailsLeft'),_c('DetailsRight')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }